const selectors = {
    body: 'body',
    popover: '.js-store-extra-info-popover',
    openBtn: '.js-store-extra-info-open-popover',
    closeBtn: '.js-store-extra-info-popover-close'
};

var $popover = null;

function showPopover(container) {
    var $closest = $(selectors.popover).closest('.container');
    $popover = container.find(selectors.popover).clone(true);
    $popover.appendTo($closest);
    $popover.addClass('show');
}

function hidePopover() {
    $popover.remove();
}

function bindEvents() {
    $(selectors.openBtn).on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        showPopover($(e.target).parent());
    });
    $(selectors.closeBtn).on('click', function (e) {
        e.preventDefault();
        $popover.remove();
    });
    $(selectors.body).on('click', function () {
        if ($(selectors.popover).hasClass('show')) {
            hidePopover();
        }
    });
}

bindEvents();
